import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FileUploader, FileUploaderProps } from './FileUploader';
import { FileUploaderArea } from './FileUploader/FileUploaderArea';

interface ConnectedFileUploaderProps extends Omit<FileUploaderProps, 'onChange' | 'value' | 'onFilesRejection'> {
  name?: string;
  rejectedFilesName?: string;
  onChangeFiles?: () => void;
  areaOnly?: boolean;
}

export const ConnectedFileUploader = ({
  name = 'files',
  rejectedFilesName = 'rejectedFileNames',
  onChangeFiles,
  areaOnly,
  ...delegatedProps
}: ConnectedFileUploaderProps) => {
  const { register, setValue, getValues, unregister } = useFormContext();

  useEffect(() => {
    register(rejectedFilesName);
    setValue(rejectedFilesName, []);
    return () => unregister(rejectedFilesName);
  }, [rejectedFilesName, register, setValue, unregister]);

  const onFilesRejection = (files: string[]) => {
    const oldFiles = getValues(rejectedFilesName) ?? [];
    setValue(rejectedFilesName, [...oldFiles, ...files]);
  };

  return (
    <Controller
      name={name}
      render={({ onChange, value }) =>
        areaOnly ? (
          <FileUploaderArea {...delegatedProps} onFilesRejection={onFilesRejection} onChange={onChange} value={value} />
        ) : (
          <FileUploader
            {...delegatedProps}
            onFilesRejection={onFilesRejection}
            onChange={(f) => {
              onChange(f);
              if (onChangeFiles) onChangeFiles();
            }}
            value={value}
          />
        )
      }
    />
  );
};
